import { IPageRange } from '@/shared/interfaces/page-range';

export const pageRange = (payload?: IPageRange) => {
  if (payload) {
    const currentRangeMin = (payload.recordsPerPage * (payload.currentPage - 1)) + 1;
    const currentRangeMax = payload.totalPages !== payload.currentPage
      ? payload.currentPage * payload.recordsPerPage
      : payload.totalRecords;

    return {
      totalRecords: parseInt(`${payload.totalRecords}`, 10),
      totalPages: parseInt(`${payload.totalPages}`, 10),
      currentPage: parseInt(`${payload.currentPage}`, 10),
      currentRange: `${currentRangeMin} - ${currentRangeMax}`,
      recordsPerPage: payload.recordsPerPage,
    };
  }
  return {
    totalRecords: 1,
    totalPages: 1,
    currentPage: 1,
    currentRange: `1 - 1`,
    recordsPerPage: 20,
  };
};
